import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { LinkField, OptionalArrayField } from '@uncinc/react-drupal-core/types';

import './style.scss';

interface QuickLinksProps {
  title?: string;
  links: OptionalArrayField<[LinkField]>;
}

const QuickLinks = ({ title, links }: QuickLinksProps) => (
  <div className="QuickLinks__wrapper">
    <div className="QuickLinks">
      {title && <span className="QuickLinks__title">{title}</span>}
      <ul>
        {links.map((link) => {
          const { title: linkTitle } = link;
          const { uri } = link;
          const isExternal = uri.startsWith('http');

          const linkClass = classNames(
            'icon-before icon-variant-4 magic-line--after',
            isExternal ? 'icon-arrow-top-right' : 'icon-arrow-right',
          );

          return (
            <li
              key={uri}
              className={linkClass}
            >
              <CoreLink to={uri}>{linkTitle}</CoreLink>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);

export default QuickLinks;
